import { connect } from 'react-redux'
import { browserHistory } from 'react-router';
import { submitForm, stopSubmitForm, getNextStep } from '../actions/users';
import SelfieWithDocument from '../components/SelfieWithDocument';


const mapStateToProps = (state) => {
    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getStep(values, dispatch) {
            dispatch(submitForm());
            return dispatch(getNextStep()).then((result) => {
                if (typeof(result.payload.data.endpoint) !== "undefined") {
                    sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                    dispatch(stopSubmitForm());
                    browserHistory.push(result.payload.data.endpoint);
                }
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelfieWithDocument);


/** WEBPACK FOOTER **
 ** ./src/containers/SelfieWithDocumentContainer.js
 **/